const wistiaEmbed = (scrollTrigger) => {
	
	const hasVideo = $('.video-embed') || null;

	if (hasVideo.length) {

		window.wistiaDisableMux = true;

		$.getScript( 'https://fast.wistia.com/assets/external/E-v1.js', function() {
			window._wq = window._wq || [];

			$('.video-embed').each((idx, el) => {
				const hash = $(el).data('hash');
				const team = $(el).parents('.team-slide').length > 0;
				
				_wq.push({
					id: hash,
					options: team ? {
						controlsVisibleOnLoad: false,
						playButton: false,
						plugin: {
							videoThumbnail: {
								on: true,
								hashedId: hash,
								trimStart: 8,
								trimEnd: 13,
								async: false
							}
						}
					} : null,
					onReady: videoOnReady
				});
			})

			function videoOnReady(video) {
				var $videoWrap = video.grid.wrapper.closest('.video-embed'),
						$overlay = $($videoWrap).find('.video-overlay'),
						vidMeta = video.data.media,
						$vidTitle = vidMeta.name,
						$vidRuntime = new Date(vidMeta.duration * 1000).toISOString().substr(11, 8),
						$titleEl = $($videoWrap).find('.video-title'),
						$timeEl = $($videoWrap).find('.video-runtime');

				$titleEl.text($vidTitle);
				$timeEl.text($vidRuntime);
				
				scrollTrigger.refresh(true);

				$overlay.on('click', function() {
					video.play();
					$(this).fadeOut('slow');
				});
			}
		});

	}
	
	const videoModal = $('[data-wistiaHash]');

	if (videoModal.length) {
		videoModal.each( (idx, el) => {
			const hash = $(el).data('wistiahash');
			$.getScript('https://fast.wistia.com/assets/external/E-v1.js', function() {
				$.getScript( 'https://fast.wistia.com/embed/medias/' + hash + '.jsonp', function() {
					console.log('wistia embed script loaded');
				});
			});
		});
	}
			 
}

export {
	wistiaEmbed
};
